import { render, staticRenderFns } from "./foother.vue?vue&type=template&id=fb8c2720&"
import script from "./foother.vue?vue&type=script&lang=js&"
export * from "./foother.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports